// client/src/components/doctors/Appointments/DoctorAppointments.jsx - COMPLETE FIXED VERSION
import React, { useState, useEffect } from 'react';
import doctorService from '../../../services/doctorService';
import billingService from '../../../services/billingService';
import { format, isToday, isTomorrow, isPast, addMinutes } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import '../../../styles/components/doctor/DoctorAppointments.css';

import neurolexLogo from '../../../assets/images/Neurolex_Logo_New.png';

import indicatorIconAppointments from '../../../assets/icons/indicators/HeaderIndicator_Appointments.png';
import paymentModalIndicator from '../../../assets/icons/indicators/Indicator_Payment_Modal.png';
import exportPdfIcon from '../../../assets/logo/pdf_icon.svg'; 
import searchIcon from '../../../assets/icons/indicators/search_icon.svg'; 

import AppointmentCard from './AppointmentCard';
import BankDropdown from '../../common/BankDropdown';
import BillingPaymentSection from './BillingPaymentSection';

import acceptIcon from '../../../assets/logo/accept_icon.svg'; 
import declineIcon from '../../../assets/logo/reject_icon.svg'; 
import viewIcon from '../../../assets/logo/view_icon2.svg'; 
import rescheduleIcon from '../../../assets/logo/change_white_icon.svg'; 

const HistoryFilterComponent = ({ 
  historySearchQuery, 
  setHistorySearchQuery,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  selectedHistoryPatient,
  setSelectedHistoryPatient,
  selectedHistoryStatus,
  setSelectedHistoryStatus,
  getHistoryPatients,
  exportHistoryToPDF,
  getHistoryAppointments,
  searchIcon,
  exportPdfIcon
}) => {
  const historyPatients = getHistoryPatients();
  const historyStatuses = ['Completed', 'Cancelled', 'Declined'];
  
  return (
    <div className="doctor-appointments-history-filters">
      <div className="doctor-appointments-filter-top-row">
        <div className="doctor-appointments-search-bar">
          <div className="doctor-appointments-search-wrapper">
            <img 
              src={searchIcon} 
              alt="Search" 
              className="doctor-appointments-search-icon"
            />
            <input
              type="text"
              placeholder="Search by patient, date, type, or status..."
              value={historySearchQuery}
              onChange={(e) => setHistorySearchQuery(e.target.value)}
              className="doctor-appointments-search-input"
            />
          </div>
        </div>
        
        <div className="doctor-appointments-filter-group">
          <label>Show</label>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            className="doctor-appointments-filter-select"
          >
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>
      
      <div className="doctor-appointments-filter-bottom-row">
        <div className="doctor-appointments-filter-left">
          <div className="doctor-appointments-filter-group">
            <label>Patient</label>
            <select
              value={selectedHistoryPatient}
              onChange={(e) => setSelectedHistoryPatient(e.target.value)}
              className="doctor-appointments-filter-select"
            >
              <option value="">All (Default)</option>
              {historyPatients.map(patient => (
                <option key={patient._id} value={patient._id}>
                  {patient.firstName} {patient.lastName}
                </option>
              ))}
            </select>
          </div>
          
          <div className="doctor-appointments-filter-group">
            <label>Status</label>
            <select
              value={selectedHistoryStatus}
              onChange={(e) => setSelectedHistoryStatus(e.target.value)}
              className="doctor-appointments-filter-select"
            >
              <option value="">All (Default)</option>
              {historyStatuses.map(status => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <button 
          className="doctor-appointments-export-btn"
          onClick={exportHistoryToPDF}
          disabled={getHistoryAppointments().length === 0}
        >
          <img 
            src={exportPdfIcon} 
            alt="Export" 
            className="doctor-appointments-export-icon"
          />
          Export PDF
        </button>
      </div>
    </div>
  );
};

const DoctorAppointments = () => {
  // States
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  // History filter states
  const [historySearchQuery, setHistorySearchQuery] = useState('');
  const [selectedHistoryPatient, setSelectedHistoryPatient] = useState('');
  const [selectedHistoryStatus, setSelectedHistoryStatus] = useState('');

  
    
  // Modal states
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [showPaymentSetupModal, setShowPaymentSetupModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const [showViewModal, setShowViewModal] = useState(false);
  const [viewAppointment, setViewAppointment] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Form states
  const [responseMessage, setResponseMessage] = useState('');
  const [responseAction, setResponseAction] = useState('');
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');
  
  // Billing states
  const [billingData, setBillingData] = useState([]);
  const [billingSearchQuery, setBillingSearchQuery] = useState('');
  const [selectedPatient, setSelectedPatient] = useState('');
  const [billingStatusFilter, setBillingStatusFilter] = useState('all');
  
  
  const getHistoryPatients = () => {
  const historyAppointments = getHistoryAppointments();
  const uniquePatients = [];
  const seenPatientIds = new Set();
  
  historyAppointments.forEach(appointment => {
    if (appointment.patient && !seenPatientIds.has(appointment.patient._id)) {
      uniquePatients.push(appointment.patient);
      seenPatientIds.add(appointment.patient._id);
    }
  });
  
  return uniquePatients.sort((a, b) => 
    `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)
  );
};

  const paginateData = (data, currentPage, itemsPerPage) => {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return {
    paginatedData: data.slice(startIndex, endIndex),
    totalPages: Math.ceil(data.length / itemsPerPage),
    totalItems: data.length
  };
};

  // Payment setup states
  const [paymentMethods, setPaymentMethods] = useState({
    gcash: { qrCode: null, enabled: false },
    paymaya: { qrCode: null, enabled: false },
    bankAccounts: []
  });
  const [newBankAccount, setNewBankAccount] = useState({
    bankName: '',
    accountName: '',
    accountNumber: ''
  });

  // Fetch data on component mount
  useEffect(() => {
    fetchAppointments();
    fetchPatients();
    fetchBillingData();
    fetchPaymentMethods();
  }, []);

  const fetchAppointments = async () => {
  try {
    setLoading(true);
    const response = await doctorService.getAppointments();
    
    // 🚨 DEBUG: Log appointments data
    console.log('📋 Appointments response:', response);
    console.log('📋 Appointments array:', response.data);
    console.log('📋 Number of appointments:', response.data?.length || 0);
    
    // Log each appointment's payment info
    if (response.data) {
      response.data.forEach((apt, index) => {
        console.log(`📋 Appointment ${index + 1}:`, {
          id: apt._id,
          patient: `${apt.patient?.firstName || 'Unknown'} ${apt.patient?.lastName || 'Patient'}`,
          status: apt.status,
          appointmentType: apt.appointmentType,
          paymentAmount: apt.payment?.amount || apt.sessionFee || 'No payment info',
          paymentStatus: apt.payment?.status || apt.billingStatus || 'No payment status'
        });
      });
    }
    
    if (response.success) {
      setAppointments(response.data || []);
    } else {
      setError('Failed to load appointments');
    }
  } catch (err) {
    console.error('❌ Error fetching appointments:', err);
    setError('Error fetching appointments');
  } finally {
    setLoading(false);
  }
};

  const fetchPatients = async () => {
    try {
      const response = await doctorService.getPatients();
      if (response.success) {
        setPatients(response.patients || []);
      }
    } catch (err) {
      console.error('Error fetching patients:', err);
    }
  };

  const fetchBillingData = async () => {
  try {
    console.log('🔍 Starting billing data fetch...');
    
    // Check if billingService exists
    if (!billingService || !billingService.getBillingRecords) {
      console.error('❌ billingService or getBillingRecords method not found');
      return;
    }
    
    console.log('🔍 Calling billingService.getBillingRecords()...');
    const response = await billingService.getBillingRecords();
    
    // 🚨 DETAILED DEBUGGING
    console.log('📊 RAW billing response:', response);
    console.log('📊 Response success:', response?.success);
    console.log('📊 Response data:', response?.data);
    console.log('📊 Response data type:', typeof response?.data);
    console.log('📊 Response data length:', response?.data?.length);
    
    if (response && response.success && response.data) {
      console.log('✅ Setting billing data with', response.data.length, 'records');
      
      // 🚨 LOG EACH BILLING RECORD
      response.data.forEach((record, index) => {
        console.log(`📊 Billing Record ${index + 1}:`, {
          id: record.id,
          patientName: record.patientName,
          sessionFee: record.sessionFee,
          status: record.status,
          appointmentDate: record.appointmentDate
        });
      });
      
      setBillingData(response.data);
      console.log('✅ Billing data set in React state');
      
    } else {
      console.log('❌ Invalid response structure:', {
        hasResponse: !!response,
        hasSuccess: !!response?.success,
        hasData: !!response?.data,
        success: response?.success,
        dataType: typeof response?.data
      });
      
      // Set empty array instead of mock data
      setBillingData([]);
    }
    
  } catch (err) {
    console.error('❌ BILLING FETCH ERROR:', err);
    console.error('❌ Error name:', err.name);
    console.error('❌ Error message:', err.message);
    console.error('❌ Error stack:', err.stack);
    
    // 🚨 CHECK IF THIS IS A NETWORK ERROR
    if (err.response) {
      console.error('❌ Server responded with error:', {
        status: err.response.status,
        statusText: err.response.statusText,
        data: err.response.data
      });
    } else if (err.request) {
      console.error('❌ Network error - no response received:', err.request);
    }
    
    // 🚨 REMOVE MOCK DATA - Let's see what's actually happening
    setBillingData([]);
    setError('Failed to fetch billing data: ' + err.message);
  }
};

  const fetchPaymentMethods = async () => {
    try {
      const response = await billingService.getPaymentMethods();
      if (response.success) {
        setPaymentMethods(response.data || {
          gcash: { qrCode: null, enabled: false },
          paymaya: { qrCode: null, enabled: false },
          bankAccounts: []
        });
      }
    } catch (err) {
      console.error('Error fetching payment methods:', err);
      const mockPaymentMethods = {
        gcash: { qrCode: null, enabled: false },
        paymaya: { qrCode: null, enabled: false },
        bankAccounts: [
          { id: 1, bankName: 'BDO', accountName: 'Dr. John Smith', accountNumber: '1234567890' }
        ]
      };
      setPaymentMethods(mockPaymentMethods);
    }
  };

  const getUpcomingAppointments = () => {
    let filtered = appointments.filter(apt => 
      (apt.status === 'Scheduled' && !isPast(new Date(apt.appointmentDate))) ||
      isToday(new Date(apt.appointmentDate))
    );
    
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(apt => 
        apt.patient?.firstName?.toLowerCase().includes(query) || 
        apt.patient?.lastName?.toLowerCase().includes(query) || 
        apt.appointmentType?.toLowerCase().includes(query)
      );
    }
    
    return filtered.sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate));
  };

  const getPendingAppointments = () => {
    let filtered = appointments.filter(apt => apt.status === 'Pending');
    
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(apt => 
        apt.patient?.firstName?.toLowerCase().includes(query) || 
        apt.patient?.lastName?.toLowerCase().includes(query) || 
        apt.appointmentType?.toLowerCase().includes(query)
      );
    }
    
    return filtered.sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate));
  };

  const getHistoryAppointments = () => {
  console.log('🔍 Getting history appointments...');
  console.log('🔍 Total appointments available:', appointments.length);
  
  let filtered = appointments.filter(apt => {
    const isHistoryStatus = apt.status === 'Completed' || 
                           apt.status === 'Cancelled' || 
                           apt.status === 'Declined';
    const isPastScheduled = apt.status === 'Scheduled' && 
                           isPast(new Date(apt.appointmentDate));
    const hasResponse = apt.doctorResponse && 
                       (apt.status === 'Scheduled' || apt.status === 'Declined');
    
    return isHistoryStatus || isPastScheduled || hasResponse;
  });
  
  // Apply search query filter - searches across multiple fields
  if (historySearchQuery.trim() !== '') {
    const query = historySearchQuery.toLowerCase();
    filtered = filtered.filter(apt => {
      // Search in patient name
      const patientName = `${apt.patient?.firstName || ''} ${apt.patient?.lastName || ''}`.toLowerCase();
      const matchesPatientName = patientName.includes(query);
      
      // Search in appointment type
      const matchesType = apt.appointmentType?.toLowerCase().includes(query);
      
      // Search in status
      const matchesStatus = apt.status?.toLowerCase().includes(query);
      
      // Search in date (format: "Jan 15, 2024" or "Today" or "Yesterday")
      const appointmentDate = new Date(apt.appointmentDate);
      const dateString = format(appointmentDate, 'MMM dd, yyyy').toLowerCase();
      const matchesDate = dateString.includes(query);
      
      // Search in time (format: "2:30 PM")
      const timeString = format(appointmentDate, 'h:mm a').toLowerCase();
      const matchesTime = timeString.includes(query);
      
      // Search in full date-time string
      const fullDateTime = formatAppointmentTime(apt.appointmentDate).toLowerCase();
      const matchesFullDateTime = fullDateTime.includes(query);
      
      // Return true if ANY field matches
      return matchesPatientName || matchesType || matchesStatus || 
             matchesDate || matchesTime || matchesFullDateTime;
    });
  }
  
  // Apply patient filter
  if (selectedHistoryPatient) {
    filtered = filtered.filter(apt => apt.patient?._id === selectedHistoryPatient);
  }
  
  // Apply status filter
  if (selectedHistoryStatus) {
    filtered = filtered.filter(apt => apt.status === selectedHistoryStatus);
  }
  
  console.log(`🔍 After all filters: ${filtered.length} appointments`);
  
  return filtered.sort((a, b) => new Date(b.appointmentDate) - new Date(a.appointmentDate));
};

const isAppointmentSoon = (appointment) => {
  if (!appointment.appointmentDate) return false;
  
  // Check if appointment is for today
  const appointmentStr = appointment.appointmentDate;
  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  
  // Extract date from appointment string (YYYY-MM-DD)
  const dateMatch = appointmentStr.match(/^(\d{4}-\d{2}-\d{2})/);
  if (!dateMatch) return false;
  
  const appointmentDateStr = dateMatch[0];
  
  // Show ALL scheduled appointments for today
  return appointment.status === 'Scheduled' && appointmentDateStr === todayStr;
};

const getSoonAppointments = () => {
  let filtered = appointments.filter(apt => 
    apt.status === 'Scheduled' && isAppointmentSoon(apt)
  );
  
  // Add the logging code right here, after filtering but before search filtering
  console.log('All appointments:', appointments.length);
  console.log('Filtered appointments:', filtered.length);
  filtered.forEach((apt, index) => {
    console.log(`Appointment ${index + 1}:`, {
      patient: `${apt.patient?.firstName || 'Unknown'} ${apt.patient?.lastName || 'Patient'}`,
      time: apt.appointmentDate,
      status: apt.status,
      isToday: isToday(new Date(apt.appointmentDate))
    });
  });
  
  if (searchQuery.trim() !== '') {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(apt => 
      apt.patient?.firstName?.toLowerCase().includes(query) || 
      apt.patient?.lastName?.toLowerCase().includes(query) || 
      apt.appointmentType?.toLowerCase().includes(query)
    );
  }
  
  return filtered.sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate));
};


const createBillingForAppointment = async (appointment) => {
  try {
    console.log('🔄 Creating billing record for accepted appointment:', appointment);
    
    // Call the billing service to create a billing record
    const response = await billingService.createBillingFromAppointment(appointment);
    
    if (response.success) {
      console.log('✅ Billing record created successfully:', response.data);
      
      // Refresh billing data
      fetchBillingData();
    }
  } catch (error) {
    console.error('❌ Error creating billing record:', error);
    setError('Failed to create billing record');
  }
};

  const handleAppointmentResponse = async () => {
  if (!selectedAppointment || !responseAction) return;
  
  try {
    let response;
    if (responseAction === 'accept') {
      response = await doctorService.acceptAppointment(selectedAppointment._id, responseMessage);
    } else {
      response = await doctorService.declineAppointment(selectedAppointment._id, responseMessage);
    }
    
    if (response.success) {
      // Update the appointments state
      const updatedAppointments = appointments.map(apt => 
        apt._id === selectedAppointment._id 
          ? { 
              ...apt, 
              status: responseAction === 'accept' ? 'Scheduled' : 'Declined',
              doctorResponse: {
                responseDate: new Date().toISOString(),
                responseMessage
              }
            } 
          : apt
      );
      
      setAppointments(updatedAppointments);
      
      // If accepted, create billing record
      if (responseAction === 'accept') {
        const acceptedAppointment = updatedAppointments.find(apt => apt._id === selectedAppointment._id);
        if (acceptedAppointment) {
          await createBillingForAppointment(acceptedAppointment);
        }
      }
      
      closeResponseModal();
    }
  } catch (err) {
    setError(`Error ${responseAction}ing appointment`);
  }
};

  const handleReschedule = async () => {
  if (!selectedAppointment || !newDate || !newTime) return;
  
  try {
    // ✅ FIX: Create ISO string without timezone conversion
    // This ensures the time is stored exactly as entered
    const appointmentDateTimeString = `${newDate}T${newTime}:00.000Z`;
    
    console.log('Rescheduling to:', appointmentDateTimeString);
    
    const response = await doctorService.rescheduleAppointment(
      selectedAppointment._id, 
      appointmentDateTimeString
    );
    
    if (response.success) {
      setAppointments(prevAppointments => 
        prevAppointments.map(apt => 
          apt._id === selectedAppointment._id 
            ? { ...apt, appointmentDate: appointmentDateTimeString } 
            : apt
        )
      );
      closeRescheduleModal();
    }
  } catch (err) {
    setError('Error rescheduling appointment');
  }
};

  const handleQRCodeUpload = async (type, file) => {
    if (!file) return;
    
    try {
      console.log(`Uploading ${type} QR code...`);
      const response = await billingService.uploadQRCode(type, file);
      
      if (response.success) {
        setPaymentMethods(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            qrCode: response.qrCodeUrl,
            enabled: true
          }
        }));
        console.log(`${type} QR code uploaded successfully`);
      }
    } catch (error) {
      console.error(`Error uploading ${type} QR code:`, error);
      setError(`Failed to upload ${type} QR code`);
    }
  };

  const handleAddBankAccount = async () => {
    if (!newBankAccount.bankName || !newBankAccount.accountName || !newBankAccount.accountNumber) {
      setError('Please fill in all bank account fields');
      return;
    }
    
    try {
      console.log('Adding bank account:', newBankAccount);
      const response = await billingService.addBankAccount(newBankAccount);
      
      if (response.success) {
        setPaymentMethods(prev => ({
          ...prev,
          bankAccounts: [...prev.bankAccounts, response.bankAccount]
        }));
        
        setNewBankAccount({
          bankName: '',
          accountName: '',
          accountNumber: ''
        });
        
        console.log('Bank account added successfully');
      }
    } catch (error) {
      console.error('Error adding bank account:', error);
      setError('Failed to add bank account');
    }
  };

  const handleRemoveBankAccount = async (accountId) => {
    try {
      console.log('Removing bank account:', accountId);
      const response = await billingService.removeBankAccount(accountId);
      
      if (response.success) {
        setPaymentMethods(prev => ({
          ...prev,
          bankAccounts: prev.bankAccounts.filter(account => account.id !== accountId)
        }));
        
        console.log('Bank account removed successfully');
      }
    } catch (error) {
      console.error('Error removing bank account:', error);
      setError('Failed to remove bank account');
    }
  };

  const handleJoinMeeting = (appointment) => {
  const meetingLink = appointment.meetingLink;
  
  if (!meetingLink) {
    alert('No meeting link available for this appointment.');
    return;
  }
  
  console.log('Doctor joining meeting:', meetingLink);
  
  // Determine meeting platform
  const getMeetingPlatform = (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === 'meet.google.com') return 'Google Meet';
      if (urlObj.hostname === 'meet.jit.si') return 'Jitsi Meet';
      if (urlObj.hostname.includes('zoom')) return 'Zoom';
      return 'Video Conference';
    } catch (e) {
      return 'Video Conference';
    }
  };
  
  const platform = getMeetingPlatform(meetingLink);
  
  // FIX: Extract time without timezone conversion
  const getDisplayTime = (dateString) => {
    const match = dateString.match(/T(\d{2}):(\d{2})/);
    if (!match) return 'Invalid time';
    
    const hours = parseInt(match[1]);
    const minutes = match[2];
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    
    return `${hour12}:${minutes} ${ampm}`;
  };
  
  // Show confirmation dialog
  const confirmed = window.confirm(
    `Join ${platform} session with ${appointment.patient?.firstName} ${appointment.patient?.lastName}?\n\n` +
    `Session Platform: ${platform}\n` +
    `Time: ${getDisplayTime(appointment.appointmentDate)}\n\n` + // ← FIXED LINE
    `This will open the video conference in a new window.`
  );
  
  if (confirmed) {
    // Open meeting in new window/tab
    window.open(meetingLink, '_blank', 'noopener,noreferrer');
  }
};

  const handleSavePaymentMethods = async () => {
    try {
      console.log('Saving payment methods:', paymentMethods);
      const response = await billingService.updatePaymentMethods(paymentMethods);
      
      if (response.success) {
        console.log('Payment methods saved successfully');
        setShowPaymentSetupModal(false);
        
        setTimeout(() => {
          setError(null);
        }, 3000);
      }
    } catch (error) {
      console.error('Error saving payment methods:', error);
      setError('Failed to save payment methods');
    }
  };

  const openResponseModal = (appointment, action) => {
    setSelectedAppointment(appointment);
    setResponseAction(action);
    setResponseMessage('');
    setShowResponseModal(true);
  };

  const closeResponseModal = () => {
    setShowResponseModal(false);
    setSelectedAppointment(null);
    setResponseMessage('');
    setResponseAction('');
  };

  // ✅ FIXED: No timezone conversion - use database time as-is
  const openRescheduleModal = (appointment) => {
    setSelectedAppointment(appointment);
    
    const appointmentDate = new Date(appointment.appointmentDate);
    setNewDate(format(appointmentDate, 'yyyy-MM-dd'));
    setNewTime(format(appointmentDate, 'HH:mm'));
    setShowRescheduleModal(true);
  };

  const closeRescheduleModal = () => {
    setShowRescheduleModal(false);
    setSelectedAppointment(null);
    setNewDate('');
    setNewTime('');
  };

  const openViewModal = (appointment) => {
  setViewAppointment(appointment);
  setShowViewModal(true);
};

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewAppointment(null);
  };

  // ✅ FIXED: Display database time as-is (no conversion)
  const formatAppointmentTime = (dateString) => {
  console.log('Raw appointment date string:', dateString);
  
  try {
    // Extract date parts directly from string to avoid timezone conversion
    const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    
    if (!match) {
      console.error('Invalid date format:', dateString);
      return dateString;
    }
    
    const year = parseInt(match[1]);
    const month = parseInt(match[2]) - 1; // JS months are 0-indexed
    const day = parseInt(match[3]);
    const hours = parseInt(match[4]);
    const minutes = parseInt(match[5]);
    
    // Create a local date object but ONLY for day display logic
    const localDate = new Date();
    localDate.setFullYear(year, month, day);
    localDate.setHours(0, 0, 0, 0); // Reset time to avoid day boundary issues
    
    // Day display logic
    let dayDisplay;
    if (isToday(localDate)) {
      dayDisplay = 'Today';
    } else if (isTomorrow(localDate)) {
      dayDisplay = 'Tomorrow';
    } else {
      // Format month name and day without time conversion
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      dayDisplay = `${monthNames[month]} ${day}, ${year}`;
    }
    
    // Format time manually to avoid timezone conversion
    let hour = hours;
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12; // Convert 24h to 12h format
    const minuteStr = minutes.toString().padStart(2, '0');
    
    return `${dayDisplay} at ${hour}:${minuteStr} ${ampm}`;
  } catch (error) {
    console.error('Error formatting appointment time:', error);
    return dateString;
  }
};

  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending': return 'status-pending';
      case 'Scheduled': return 'status-scheduled';
      case 'Completed': return 'status-completed';
      case 'Cancelled': return 'status-cancelled';
      case 'Declined': return 'status-declined';
      default: return 'status-default';
    }
  };

  const getBillingStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'billing-paid';
      case 'pending': return 'billing-pending';
      case 'overdue': return 'billing-overdue';
      default: return 'billing-default';
    }
  };

  const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="doctor-appointments-pagination">
      <button 
        className="pagination-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <span>‹</span>
      </button>
      
      <div className="pagination-pages">
        {[...Array(totalPages)].map((_, index) => {
          const pageNum = index + 1;
          return (
            <button
              key={pageNum}
              className={`pagination-page ${currentPage === pageNum ? 'active' : ''}`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}
      </div>
      
      <button 
        className="pagination-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <span>›</span>
      </button>
    </div>
  );
};

const exportHistoryToPDF = () => {
  const historyData = getHistoryAppointments();
  
  if (historyData.length === 0) {
    alert('No appointment history data to export.');
    return;
  }

  // Create printable HTML content
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Appointment History Report</title>
      <style>
        @media print {
          body { margin: 0; }
          .no-print { display: none; }
        }
        body { 
          font-family: Arial, sans-serif; 
          margin: 20px; 
          color: #333;
        }
        .header { 
          margin-bottom: 30px; 
          border-bottom: 2px solid #50806b;
          padding-bottom: 15px;
        }
        .title { 
          font-size: 24px; 
          font-weight: bold; 
          margin-bottom: 10px; 
          color: #50806b;
        }
        .info { 
          font-size: 14px; 
          color: #666; 
          margin-bottom: 5px; 
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin-top: 20px; 
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        th, td { 
          border: 1px solid #ddd; 
          padding: 12px 8px; 
          text-align: left; 
          font-size: 12px;
        }
        th { 
          background-color: #50806b; 
          color: white; 
          font-weight: bold; 
          font-size: 13px;
        }
        tr:nth-child(even) { 
          background-color: #f8faf9; 
        }
        tr:hover {
          background-color: #f0f7f4;
        }
        .status-completed { color: #059669; font-weight: 500; }
        .status-cancelled { color: #dc2626; font-weight: 500; }
        .status-declined { color: #ea580c; font-weight: 500; }
        .patient-name { font-weight: 500; }
        .footer {
          margin-top: 30px;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-top: 1px solid #ddd;
          padding-top: 15px;
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="title">Appointment History Report</div>
        <div class="info">Generated on: ${new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })}</div>
        <div class="info">Total Records: ${historyData.length}</div>
        ${historySearchQuery.trim() ? `<div class="info">Search Filter: "${historySearchQuery}"</div>` : ''}
        ${selectedHistoryPatient ? `<div class="info">Patient Filter: Applied</div>` : ''}
        ${selectedHistoryStatus ? `<div class="info">Status Filter: ${selectedHistoryStatus}</div>` : ''}
      </div>
      
      <table>
        <thead>
          <tr>
            <th style="width: 25%;">Patient Name</th>
            <th style="width: 30%;">Date & Time</th>
            <th style="width: 25%;">Appointment Type</th>
            <th style="width: 10%;">Duration</th>
            <th style="width: 10%;">Status</th>
          </tr>
        </thead>
        <tbody>
          ${historyData.map(appointment => {
            const patientName = `${appointment.patient?.firstName || ''} ${appointment.patient?.lastName || ''}`.trim() || 'Unknown';
            const status = appointment.status || 'Unknown';
            return `
            <tr>
              <td class="patient-name">${patientName}</td>
              <td>${formatAppointmentTime(appointment.appointmentDate)}</td>
              <td>${appointment.appointmentType || 'Not specified'}</td>
              <td>${appointment.duration || 30} min</td>
              <td class="status-${status.toLowerCase()}">${status}</td>
            </tr>
          `;
          }).join('')}
        </tbody>
      </table>
      
      <div class="footer">
        <p>Appointment History Report - Generated by NeuroLex Platform</p>
      </div>
    </body>
    </html>
  `;

  // Open in new window and trigger print
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.focus();
  
  // Small delay to ensure content loads before printing
  setTimeout(() => {
    printWindow.print();
  }, 250);
};

  // ✅ FIXED: Complete appointments table with proper date/time display
  const renderAppointmentsTable = (appointments, title, isPendingSection = false, showHistoryFilters = false) => {
  const { paginatedData, totalPages, totalItems } = paginateData(appointments, currentPage, itemsPerPage);
  
  return (
    <div className="doctor-appointments-section">
      <div className="doctor-appointments-table-container">
      <div className="doctor-appointments-section-header">
        <h2 className="doctor-appointments-section-title">{title}</h2>
      </div>
      
       {showHistoryFilters && (
          <HistoryFilterComponent 
            historySearchQuery={historySearchQuery}
            setHistorySearchQuery={setHistorySearchQuery}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            setCurrentPage={setCurrentPage}
            selectedHistoryPatient={selectedHistoryPatient}
            setSelectedHistoryPatient={setSelectedHistoryPatient}
            selectedHistoryStatus={selectedHistoryStatus}
            setSelectedHistoryStatus={setSelectedHistoryStatus}
            getHistoryPatients={getHistoryPatients}
            exportHistoryToPDF={exportHistoryToPDF}
            getHistoryAppointments={getHistoryAppointments}
            searchIcon={searchIcon}
            exportPdfIcon={exportPdfIcon}
          />
        )}
      
      <div className="doctor-appointments-table">
        <div className="doctor-appointments-table-header">
          <div className="doctor-appointments-header-cell">Patient</div>
          <div className="doctor-appointments-header-cell">Date & Time</div>
          <div className="doctor-appointments-header-cell">Type</div>
          <div className="doctor-appointments-header-cell">Duration</div>
          <div className="doctor-appointments-header-cell">Status</div>
          <div className="doctor-appointments-header-cell">Actions</div>
        </div>
        
        {paginatedData.length === 0 ? (
          <div className="doctor-appointments-empty-state">
            <p>No {title.toLowerCase()} found</p>
          </div>
        ) : (
          paginatedData.map((appointment) => (
            <div key={appointment._id} className="doctor-appointments-table-row">
              <div className="doctor-appointments-table-cell doctor-appointments-patient-cell">
                  <div className="doctor-appointments-patient-avatar">
                    {appointment.patient?.profilePicture ? (
                      <img 
                        src={appointment.patient.profilePicture} 
                        alt={`${appointment.patient?.firstName} ${appointment.patient?.lastName}`}
                        className="doctor-appointments-avatar-img"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextElementSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <span 
                      className="doctor-appointments-avatar-initials"
                      style={{ display: appointment.patient?.profilePicture ? 'none' : 'flex' }}
                    >
                      {appointment.patient?.firstName?.[0] || 'P'}
                    </span>
                  </div>
                  <div className="doctor-appointments-patient-info">
                    <span className="doctor-appointments-patient-name">
                      {appointment.patient?.firstName} {appointment.patient?.lastName}
                    </span>
                  </div>
                </div>
              
              <div className="doctor-appointments-table-cell">
                <div className="doctor-appointments-date-time-info">
                  <span className="doctor-appointments-date-text">
                    {formatAppointmentTime(appointment.appointmentDate, appointment)}
                  </span>
                  <span className="doctor-appointments-time-range">
                    {(() => {
                      const matchStart = appointment.appointmentDate.match(/T(\d{2}):(\d{2})/);
                      if (!matchStart) return 'Invalid time';
                      
                      const hours = parseInt(matchStart[1]);
                      const minutes = matchStart[2];
                      
                      const ampm = hours >= 12 ? 'PM' : 'AM';
                      const hour12 = hours % 12 || 12;
                      const startTime = `${hour12}:${minutes} ${ampm}`;
                      
                      const duration = appointment.duration || 30;
                      let endHours = hours;
                      let endMinutes = parseInt(minutes) + duration;
                      
                      if (endMinutes >= 60) {
                        endHours += Math.floor(endMinutes / 60);
                        endMinutes = endMinutes % 60;
                      }
                      
                      const endAmpm = endHours >= 12 ? 'PM' : 'AM';
                      const endHour12 = endHours % 12 || 12;
                      const endMinutesStr = endMinutes.toString().padStart(2, '0');
                      const endTime = `${endHour12}:${endMinutesStr} ${endAmpm}`;
                      
                      return `${startTime} - ${endTime}`;
                    })()}
                  </span>
                </div>
              </div>
              
              <div className="doctor-appointments-table-cell">
                <span className="doctor-appointments-appointment-type">{appointment.appointmentType}</span>
              </div>
              
              <div className="doctor-appointments-table-cell">
                <span className="doctor-appointments-duration">{appointment.duration || 30} min</span>
              </div>
              
              <div className="doctor-appointments-table-cell">
                <span className={`doctor-appointments-status-badge doctor-appointments-${getStatusColor(appointment.status)}`}>
                  {appointment.status}
                </span>
              </div>
              
              <div className="doctor-appointments-table-cell doctor-appointments-actions-cell">
  {isPendingSection && appointment.status === 'Pending' && (
    <>
      <button 
        className="doctor-appointments-action-btn doctor-appointments-accept-btn"
        onClick={() => openResponseModal(appointment, 'accept')}
        title="Accept"
      >
        <img src={acceptIcon} alt="Accept" className="doctor-appointments-action-icon" />
      </button>
      <button 
        className="doctor-appointments-action-btn doctor-appointments-decline-btn"
        onClick={() => openResponseModal(appointment, 'decline')}
        title="Decline"
      >
        <img src={declineIcon} alt="Decline" className="doctor-appointments-action-icon" />
      </button>
    </>
  )}
  
  {!showHistoryFilters && appointment.status === 'Scheduled' && (
  <>
    <button 
      className="doctor-appointments-action-btn doctor-appointments-edit-btn"
      onClick={() => openRescheduleModal(appointment)}
      title="Reschedule"
    >
      <img src={rescheduleIcon} alt="Reschedule" className="doctor-appointments-action-icon" />
    </button>
    <button 
      className="doctor-appointments-action-btn doctor-appointments-complete-btn"
      onClick={async () => {
        const confirmed = window.confirm(
          `Mark appointment with ${appointment.patient?.firstName} ${appointment.patient?.lastName} as completed?`
        );
        
        if (confirmed) {
          try {
            const response = await doctorService.completeAppointment(appointment._id);
            
            if (response.success) {
              setAppointments(prevAppointments => 
                prevAppointments.map(apt => 
                  apt._id === appointment._id 
                    ? { 
                        ...apt, 
                        status: 'Completed',
                        meetingEndedAt: new Date().toISOString()
                      }
                    : apt
                )
              );
              
              console.log('✅ Appointment marked as completed');
            }
          } catch (err) {
            console.error('Error completing appointment:', err);
            setError('Failed to mark appointment as completed');
          }
        }
      }}
      title="Complete"
    >
      <img src={acceptIcon} alt="Complete" className="doctor-appointments-action-icon" />
    </button>
  </>
)}
  
  <button 
    className="doctor-appointments-action-btn doctor-appointments-view-btn"
    onClick={() => openViewModal(appointment)}
    title="View"
  >
    <img src={viewIcon} alt="View" className="doctor-appointments-action-icon" />
  </button>
</div>
            </div>
          ))
        )}
      </div>
      
      <PaginationComponent 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
    </div>
  );
};

  const renderSoonAppointments = () => {
  const soonAppointments = getSoonAppointments();
  
  return (
    <div className="doctor-appointments-section">
      <div className="doctor-appointments-section-header">
        <div className="doctor-appointments-header-controls">
          <span className="doctor-appointments-section-count">
            ({soonAppointments.length})
          </span>
        </div>
      </div>
      
      {/* Card View */}
      <div className="appt-card-unique-container">
        {soonAppointments.length === 0 ? (
          <div className="doctor-appointments-empty-state">
            <p>No appointments coming up soon</p>
            <p className="upcoming-note">Only appointments within 30 minutes will appear here</p>
          </div>
        ) : (
          soonAppointments.map((appointment) => (
            <AppointmentCard 
              key={appointment._id}
              appointment={appointment}
              className={`status-${getStatusColor(appointment.status)}`}
              onJoin={() => handleJoinMeeting(appointment)}
              onViewPatient={(patientId) => navigate(`/doctor/patients/${patientId}`)}
            />
          ))
        )}
      </div>
    </div>
  );
};

  const renderBillingTable = () => (
    <div className="doctor-appointments-billing-section">
      <div className="doctor-appointments-billing-header">
        <div className="doctor-appointments-billing-controls">
          <div className="doctor-appointments-search-bar">
            <input
              type="text"
              placeholder="Search billing records..."
              value={billingSearchQuery}
              onChange={(e) => setBillingSearchQuery(e.target.value)}
            />
          </div>
          
          <select
            value={selectedPatient}
            onChange={(e) => setSelectedPatient(e.target.value)}
            className="doctor-appointments-patient-filter"
          >
            <option value="">All Patients</option>
            {patients.map(patient => (
              <option key={patient._id} value={patient._id}>
                {patient.firstName} {patient.lastName}
              </option>
            ))}
          </select>
          
          <select
            value={billingStatusFilter}
            onChange={(e) => setBillingStatusFilter(e.target.value)}
            className="doctor-appointments-status-filter"
          >
            <option value="all">All Status</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="overdue">Overdue</option>
          </select>
          
          <button className="doctor-appointments-export-btn" onClick={() => console.log('Export PDF')}>
            Export PDF
          </button>
        </div>
        
        <button 
          className="doctor-appointments-setup-payment-btn"
          onClick={() => setShowPaymentSetupModal(true)}
        >
          Setup Payment Methods
        </button>
      </div>
      
      <div className="doctor-appointments-billing-table">
        <div className="doctor-appointments-table-header">
          <div className="doctor-appointments-header-cell">Appointment Schedule</div>
          <div className="doctor-appointments-header-cell">Patient Name</div>
          <div className="doctor-appointments-header-cell">Session Fee</div>
          <div className="doctor-appointments-header-cell">Billing Status</div>
          <div className="doctor-appointments-header-cell">Action</div>
        </div>
        
        {billingData.map((bill) => (
          <div key={bill.id} className="doctor-appointments-table-row">
            <div className="doctor-appointments-table-cell">
              <span className="doctor-appointments-appointment-date">
                {format(new Date(bill.appointmentDate), 'MMM dd, yyyy')}
              </span>
              <span className="doctor-appointments-appointment-time">
                {format(new Date(bill.appointmentDate), 'h:mm a')}
              </span>
            </div>
            
            <div className="doctor-appointments-table-cell">
              <span className="doctor-appointments-patient-name">{bill.patientName}</span>
            </div>
            
            <div className="doctor-appointments-table-cell">
              <span className="doctor-appointments-session-fee">${bill.sessionFee}</span>
            </div>
            
            <div className="doctor-appointments-table-cell">
              <span className={`doctor-appointments-status-badge doctor-appointments-billing-${getBillingStatusColor(bill.status)}`}>
                {bill.status.charAt(0).toUpperCase() + bill.status.slice(1)}
              </span>
            </div>
            
            <div className="doctor-appointments-table-cell">
              <button 
                className="doctor-appointments-action-btn doctor-appointments-view-btn"
                onClick={() => setShowBillingModal(true)}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="neurolex-loading-container">
        <div className="neurolex-loading-insideContainer">
        <div className="neurolex-dashboard-spinner">
          <div className="spinner-circle outer"></div>
          <div className="spinner-circle middle"></div>
          <div className="spinner-circle inner"></div>
          <div className="spinner-center">
            <img 
              src={neurolexLogo} 
              alt="NeuroLex Logo" 
              className="loading-logo"
              onError={(e) => {
                console.warn('❌ Logo failed to load from:', neurolexLogo);
                // Fallback to patient emoji if logo doesn't load
                e.target.style.display = 'none';
                const fallback = e.target.nextElementSibling;
                if (fallback) {
                  fallback.style.display = 'flex';
                  fallback.style.alignItems = 'center';
                  fallback.style.justifyContent = 'center';
                }
              }}
              onLoad={() => {
                console.log('✅ NeuroLex logo loaded successfully:', neurolexLogo);
              }}
            />
            <div className="loading-logo-fallback" style={{ display: 'none' }}>
              👥
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
  

  return (
    <div className="doctor-appointments-container">
      <div className="doctor-appointments-header">
        <div className="doctor-appointments-header-left">
          <h1 className="doctor-appointments-page-title">My Appointments</h1>
          <p className="doctor-appointments-page-subtitle">Stay connected to your care—see what's next and reflect on where you've been.</p>
        </div>
        
        
        {error && (
          <div className="doctor-appointments-error-alert">
            <span className="doctor-appointments-alert-icon">⚠️</span>
            {error}
          </div>
        )}
        
        <div className="doctor-appointments-header-controls">
        </div>
      </div>
      
      <div className="doctor-appointments-content">
        {renderSoonAppointments()}
        {renderAppointmentsTable(getUpcomingAppointments(), "All Upcoming Appointments")}
        {renderAppointmentsTable(getPendingAppointments(), "Pending Appointment Requests", true)}
        {renderAppointmentsTable(getHistoryAppointments(), "Appointment History", false, true)}
        
        <div className="doctor-appointments-billing-section-wrapper">
          <BillingPaymentSection 
            patients={patients}
            initialBillingData={billingData}
            onBillingDataChange={(newData) => setBillingData(newData)}
            onError={(errorMessage) => setError(errorMessage)}
          />
        </div>
      </div>
      
      {showResponseModal && (
        <div className="doctor-appointments-modal-overlay">
          <div className="doctor-appointments-modal">
            <div className="doctor-appointments-modal-header">
              <h3>{responseAction === 'accept' ? 'Accept' : 'Decline'} Appointment</h3>
              <button className="doctor-appointments-close-btn" onClick={closeResponseModal}>×</button>
            </div>
            
            <div className="doctor-appointments-modal-body">
              {selectedAppointment && (
                <div className="doctor-appointments-appointment-summary">
                  <p><strong>Patient:</strong> {selectedAppointment.patient?.firstName} {selectedAppointment.patient?.lastName}</p>
                  <p><strong>Date:</strong> {formatAppointmentTime(selectedAppointment.appointmentDate)}</p>
                </div>
              )}
              
            </div>
            
            <div className="doctor-appointments-modal-footer">
              <button className="doctor-appointments-cancel-btn" onClick={closeResponseModal}>
                Cancel
              </button>
              <button 
                className={`doctor-appointments-confirm-btn ${responseAction === 'accept' ? 'doctor-appointments-accept' : 'doctor-appointments-decline'}`}
                onClick={handleAppointmentResponse}
              >
                {responseAction === 'accept' ? 'Accept' : 'Decline'} Appointment
              </button>
            </div>
          </div>
        </div>
      )}
      
      {showRescheduleModal && (
        <div className="doctor-appointments-modal-overlay">
          <div className="doctor-appointments-modal">
            <div className="doctor-appointments-modal-header">
              <h3>Reschedule Appointment</h3>
              <button className="doctor-appointments-close-btn" onClick={closeRescheduleModal}>×</button>
            </div>
            
            <div className="doctor-appointments-modal-body">
              <div className="doctor-appointments-form-row">
                <div className="doctor-appointments-form-group">
                  <label>New Date</label>
                  <input
                    type="date"
                    value={newDate}
                    onChange={(e) => setNewDate(e.target.value)}
                  />
                </div>
                
                <div className="doctor-appointments-form-group">
                  <label>New Time</label>
                  <input
                    type="time"
                    value={newTime}
                    onChange={(e) => setNewTime(e.target.value)}
                  />
                </div>
              </div>
            </div>
            
            <div className="doctor-appointments-modal-footer">
              <button className="doctor-appointments-cancel-btn" onClick={closeRescheduleModal}>
                Cancel
              </button>
              <button className="doctor-appointments-confirm-btn doctor-appointments-reschedule" onClick={handleReschedule}>
                Reschedule Appointment
              </button>
            </div>
          </div>
        </div>
      )}

      {showPaymentSetupModal && (
        <div className="doctor-appointments-modal-overlay">
          <div className="doctor-appointments-modal doctor-appointments-large-modal">
            <div className="doctor-appointments-payment-modal-header">
              <div className="doctor-appointments-payment-header-left">
                <button 
                  className="doctor-appointments-back-btn"
                  onClick={() => setShowPaymentSetupModal(false)}
                >
                  <span className="doctor-appointments-back-arrow">‹</span>
                </button>
                
                <h3 className="doctor-appointments-payment-modal-title">Add Payment Option</h3>
              </div>
                
                <div className="doctor-appointments-payment-icon-container">
                  <img 
                    src={paymentModalIndicator} 
                    alt="Payment Options" 
                    className="doctor-appointments-payment-header-icon"
                  />
                </div>
              </div>
            
            <div className="doctor-appointments-modal-body">
              <div className="doctor-appointments-payment-setup-section">
                <div className="doctor-appointments-digital-payment-section-container">
                  <div className="doctor-appointments-digital-payment-header">
                    <h4 className="doctor-appointments-modal-digital-payment-title">Digital Payment QR Codes</h4>
                    <p className="doctor-appointments-modal-digital-payment-subtitle">Upload QR codes for your digital payment accounts</p>
                  </div>
                  
                  <div className="doctor-appointments-digital-payment-grid">
                    {/* GCash Upload Container */}
                    <div className="doctor-appointments-payment-upload-container">
                      <label className="doctor-appointments-payment-upload-label">GCash</label>
                      <div className="doctor-appointments-qr-upload-area">
                        {paymentMethods.gcash.qrCode ? (
                          <div className="doctor-appointments-qr-preview-container">
                            <img 
                              src={paymentMethods.gcash.qrCode} 
                              alt="GCash QR" 
                              className="doctor-appointments-qr-preview-image" 
                            />
                            <div className="doctor-appointments-qr-overlay">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleQRCodeUpload('gcash', e.target.files[0])}
                                className="doctor-appointments-qr-file-input"
                                id="gcash-upload"
                              />
                              <label htmlFor="gcash-upload" className="doctor-appointments-qr-change-btn">
                                Change Image
                              </label>
                            </div>
                          </div>
                        ) : (
                          <div className="doctor-appointments-qr-upload-placeholder">
                            <div className="doctor-appointments-upload-icon">+</div>
                            <span className="doctor-appointments-upload-text">GCash QR Code</span>
                            <span className="doctor-appointments-upload-subtext">Click or drag image here</span>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleQRCodeUpload('gcash', e.target.files[0])}
                              className="doctor-appointments-qr-file-input"
                              id="gcash-upload-new"
                            />
                            <label htmlFor="gcash-upload-new" className="doctor-appointments-qr-upload-btn">
                              Upload Image
                            </label>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* PayMaya Upload Container */}
                    <div className="doctor-appointments-payment-upload-container">
                      <label className="doctor-appointments-payment-upload-label">Maya</label>
                      <div className="doctor-appointments-qr-upload-area">
                        {paymentMethods.paymaya.qrCode ? (
                          <div className="doctor-appointments-qr-preview-container">
                            <img 
                              src={paymentMethods.paymaya.qrCode} 
                              alt="PayMaya QR" 
                              className="doctor-appointments-qr-preview-image" 
                            />
                            <div className="doctor-appointments-qr-overlay">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleQRCodeUpload('paymaya', e.target.files[0])}
                                className="doctor-appointments-qr-file-input"
                                id="paymaya-upload"
                              />
                              <label htmlFor="paymaya-upload" className="doctor-appointments-qr-change-btn">
                                Change Image
                              </label>
                            </div>
                          </div>
                        ) : (
                          <div className="doctor-appointments-qr-upload-placeholder">
                            <div className="doctor-appointments-upload-icon">+</div>
                            <span className="doctor-appointments-upload-text">Maya QR Code</span>
                            <span className="doctor-appointments-upload-subtext">Click or drag image here</span>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleQRCodeUpload('paymaya', e.target.files[0])}
                              className="doctor-appointments-qr-file-input"
                              id="paymaya-upload-new"
                            />
                            <label htmlFor="paymaya-upload-new" className="doctor-appointments-qr-upload-btn">
                              Upload Image
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

              
              <div className="doctor-appointments-payment-setup-section">
                  <h4 className="doctor-appointments-bank-section-title">Bank Account Details</h4>
                  
                  <div className="doctor-appointments-bank-account-form">
                    <div className="doctor-appointments-bank-form-field">
                      <label className="doctor-appointments-bank-field-label">Bank Name</label>
                      <BankDropdown
                        value={newBankAccount.bankName}
                        onChange={(bankName) => setNewBankAccount(prev => ({...prev, bankName}))}
                        placeholder="Select Bank"
                        accountNumber={newBankAccount.accountNumber}
                        onCardTypeDetected={(cardType) => {
                          console.log('Detected card type:', cardType);
                        }}
                        className="doctor-appointments-bank-input-dropdown"
                      />
                    </div>
                    
                    <div className="doctor-appointments-bank-form-field">
                      <label className="doctor-appointments-bank-field-label">Account Name</label>
                      <input
                        type="text"
                        placeholder="Enter account holder name..."
                        value={newBankAccount.accountName}
                        onChange={(e) => setNewBankAccount(prev => ({...prev, accountName: e.target.value}))}
                        className="doctor-appointments-bank-input"
                      />
                    </div>
                    
                    <div className="doctor-appointments-bank-form-field">
                      <label className="doctor-appointments-bank-field-label">Account Number</label>
                      <input
                        type="text"
                        placeholder="Enter account number..."
                        value={newBankAccount.accountNumber}
                        onChange={(e) => setNewBankAccount(prev => ({...prev, accountNumber: e.target.value}))}
                        className="doctor-appointments-bank-input"
                      />
                    </div>
                    
                    <button 
                      className="doctor-appointments-add-another-bank-btn"
                      onClick={handleAddBankAccount}
                      disabled={!newBankAccount.bankName || !newBankAccount.accountName || !newBankAccount.accountNumber}
                    >
                      <span className="doctor-appointments-add-icon">+</span>
                      Add Another Bank Account
                    </button>
                  </div>
                  
                  {/* Display existing bank accounts */}
                  {paymentMethods.bankAccounts && paymentMethods.bankAccounts.length > 0 && (
                    <div className="doctor-appointments-bank-accounts-list">
                      {paymentMethods.bankAccounts.map((account) => (
                        <div key={account.id} className="doctor-appointments-bank-account-item">
                          <div className="doctor-appointments-bank-account-info">
                            <span className="doctor-appointments-bank-name">{account.bankName}</span>
                            <span className="doctor-appointments-account-name">{account.accountName}</span>
                            <span className="doctor-appointments-account-number">
                              {account.accountNumber.replace(/(\d{4})/g, '$1 ').trim()}
                            </span>
                          </div>
                          <button 
                            className="doctor-appointments-remove-bank-btn" 
                            onClick={() => handleRemoveBankAccount(account.id)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                </div>
            
            <div className="doctor-appointments-modal-footer">
              <button className="doctor-appointments-cancel-btn" onClick={() => setShowPaymentSetupModal(false)}>
                Cancel
              </button>
              <button className="doctor-appointments-confirm-btn doctor-appointments-save" onClick={handleSavePaymentMethods}>
               Save Payment Methods
             </button>
           </div>
         </div>
       </div>
     )}
     
     {showBillingModal && (
       <div className="doctor-appointments-modal-overlay">
         <div className="doctor-appointments-modal">
           <div className="doctor-appointments-modal-header">
             <h3>Billing Details</h3>
             <button className="doctor-appointments-close-btn" onClick={() => setShowBillingModal(false)}>×</button>
           </div>
           
           <div className="doctor-appointments-modal-body">
             <div className="doctor-appointments-billing-details">
               <p><strong>Patient:</strong> John Doe</p>
               <p><strong>Session Date:</strong> Jan 15, 2024</p>
               <p><strong>Session Fee:</strong> $150</p>
               <p><strong>Status:</strong> <span className="doctor-appointments-status-badge doctor-appointments-billing-paid">Paid</span></p>
               <p><strong>Payment Method:</strong> GCash</p>
               <p><strong>Transaction ID:</strong> TXN123456789</p>
             </div>
           </div>
           
           <div className="doctor-appointments-modal-footer">
             <button className="doctor-appointments-confirm-btn" onClick={() => setShowBillingModal(false)}>
               Close
             </button>
           </div>
         </div>
       </div>
     )}
     {showViewModal && viewAppointment && (
  <div className="doctor-appointments-modal-overlay">
    <div className="doctor-appointments-modal doctor-appointments-view-modal">
      <div className="doctor-appointments-modal-header">
        <h3>Appointment Details</h3>
        <button className="doctor-appointments-close-btn" onClick={closeViewModal}>×</button>
      </div>
      
      <div className="doctor-appointments-modal-body">
        {/* Patient Information Section */}
        <div className="doctor-appointments-view-section">
          <h4 className="doctor-appointments-view-section-title">Patient Information</h4>
          <div className="doctor-appointments-patient-info-view">
            <div className="doctor-appointments-patient-avatar-large">
              {viewAppointment.patient?.profilePicture ? (
                <img 
                  src={viewAppointment.patient.profilePicture} 
                  alt={`${viewAppointment.patient?.firstName} ${viewAppointment.patient?.lastName}`}
                  className="doctor-appointments-avatar-img"
                />
              ) : (
                <span className="doctor-appointments-avatar-initials">
                  {viewAppointment.patient?.firstName?.[0]}{viewAppointment.patient?.lastName?.[0]}
                </span>
              )}
            </div>
            <div className="doctor-appointments-patient-details">
              <p className="doctor-appointments-patient-fullname">
                {viewAppointment.patient?.firstName} {viewAppointment.patient?.lastName}
              </p>
              <p className="doctor-appointments-patient-email">
                {viewAppointment.patient?.email}
              </p>
            </div>
          </div>
        </div>

        {/* Schedule Information Section */}
        <div className="doctor-appointments-view-section">
          <h4 className="doctor-appointments-view-section-title">Schedule Information</h4>
          <div className="doctor-appointments-schedule-info">
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Date & Time:</span>
              <span className="doctor-appointments-info-value">
                {formatAppointmentTime(viewAppointment.appointmentDate)}
              </span>
            </div>
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Appointment Type:</span>
              <span className="doctor-appointments-info-value">
                {viewAppointment.appointmentType}
              </span>
            </div>
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Duration:</span>
              <span className="doctor-appointments-info-value">
                {viewAppointment.duration || 30} minutes
              </span>
            </div>
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Status:</span>
              <span className={`doctor-appointments-status-badge doctor-appointments-${getStatusColor(viewAppointment.status)}`}>
                {viewAppointment.status}
              </span>
            </div>
          </div>
        </div>

        {/* Billing Section */}
        <div className="doctor-appointments-view-section">
          <h4 className="doctor-appointments-view-section-title">Billing Information</h4>
          <div className="doctor-appointments-billing-info">
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Session Fee:</span>
              <span className="doctor-appointments-info-value doctor-appointments-amount">
                ₱{viewAppointment.payment?.amount || viewAppointment.sessionFee || '0.00'}
              </span>
            </div>
            <div className="doctor-appointments-info-row">
              <span className="doctor-appointments-info-label">Payment Status:</span>
              <span className={`doctor-appointments-payment-status ${viewAppointment.payment?.status || 'pending'}`}>
                {(viewAppointment.payment?.status || 'pending').replace('_', ' ').toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="doctor-appointments-modal-footer">
  
  {/* Buttons for Pending Appointments */}
{viewAppointment.status === 'Pending' && (
  <div className="doctor-appointments-pending-actions">
    <button 
      className="doctor-appointments-pending-action-btn doctor-appointments-pending-decline-btn"
      onClick={() => {
        closeViewModal();
        openResponseModal(viewAppointment, 'decline');
      }}
    >
      Decline
    </button>
    <button 
      className="doctor-appointments-pending-action-btn doctor-appointments-pending-accept-btn"
      onClick={() => {
        closeViewModal();
        openResponseModal(viewAppointment, 'accept');
      }}
    >
      Accept
    </button>
  </div>
  )}
  
  {/* Button for Scheduled Appointments */}
  {/* Button for Scheduled Appointments */}
  {viewAppointment.status === 'Scheduled' && (
    <button 
      className="doctor-appointments-confirm-btn doctor-appointments-complete"
      onClick={async () => {
        const confirmed = window.confirm(
          `Mark appointment with ${viewAppointment.patient?.firstName} ${viewAppointment.patient?.lastName} as completed?`
        );
        
        if (confirmed) {
          try {
            const response = await doctorService.completeAppointment(viewAppointment._id);
            
            if (response.success) {
              setAppointments(prevAppointments => 
                prevAppointments.map(apt => 
                  apt._id === viewAppointment._id 
                    ? { 
                        ...apt, 
                        status: 'Completed',
                        meetingEndedAt: new Date().toISOString()
                      }
                    : apt
                )
              );
              
              closeViewModal();
              console.log('✅ Appointment marked as completed');
            }
          } catch (err) {
            console.error('Error completing appointment:', err);
            setError('Failed to mark appointment as completed');
          }
        }
      }}
    >
      Mark as Completed
    </button>
  )}
</div>
    </div>
  </div>
)}
   </div>
 );
};

export default DoctorAppointments;